import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-jk-prod-auth',
  templateUrl: './jk-prod-auth.component.html',
  styleUrls: ['./jk-prod-auth.component.css']
})
export class JkProdAuthComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
